import React, { useEffect, useState } from 'react';
import API_URL from '../config';

// "A new version is available" bar (October 2026). After a deploy, pages left open keep running
// the old bundle until refreshed, which caused confusing behaviour (e.g. old Send to Client
// rules). Compares this page's main.*.js with the live one from /api/app-version every 5 minutes
// and whenever the tab becomes visible. Never reloads by itself, so unsaved work isn't lost.
const CHECK_EVERY_MS = 5 * 60 * 1000;

function currentBundle() {
  const s = document.querySelector('script[src*="/static/js/main."]');
  if (!s) return null; // dev server: no hashed bundle, nothing to compare
  return new URL(s.src, window.location.href).pathname;
}

export default function UpdateBanner() {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return undefined;
    const check = async () => {
      try {
        const res = await fetch(`${API_URL}/api/app-version`, { cache: 'no-store' });
        const { mainJs } = await res.json();
        if (mainJs && mainJs !== mine) setOutdated(true);
      } catch (e) { /* offline or mid-deploy: try again next time */ }
    };
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    const timer = setInterval(check, CHECK_EVERY_MS);
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', onVisible); };
  }, []);

  if (!outdated) return null;
  return (
    <div style={{
      position: 'fixed', top: 'env(safe-area-inset-top, 0px)', left: 0, right: 0, zIndex: 2000,
      background: '#1e2d5a', color: '#fff', padding: '10px 16px', display: 'flex', gap: 14,
      alignItems: 'center', justifyContent: 'center', fontFamily: "'Sora', sans-serif", fontSize: 13,
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    }}>
      <span>A new version of the CRM is available. Save anything you're working on, then reload.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{ background: '#f59e0b', color: '#1e2d5a', border: 'none', borderRadius: 6, padding: '6px 14px', fontWeight: 700, cursor: 'pointer' }}
      >
        Reload
      </button>
    </div>
  );
}
